import React from 'react';

import { SimpleFooterLink, SimpleFooterMenuItem } from 'types/studio/footer';

import FooterMenuItem from '../FooterMenuItem/FooterMenuItem';
import { useFooterContext } from '../FooterContext';

import styles from './styles.module.scss';

const FooterMenu = () => {
  const {
    data: { menus },
    footerSettings
  } = useFooterContext();

  if (!menus) {
    /**
     * should never happen, validated by Sanity and by Zod
     */
    return null;
  }

  const hasPageLink = Boolean(
    footerSettings?.hasDifferentLinks && footerSettings.shopLinks?.title?.length
  );

  const getInternalLinks: SimpleFooterLink[] = footerSettings?.shopLinks?.links || [];

  const getPageLink: SimpleFooterMenuItem = {
    _type: 'menu',
    _key: 'shopLinks',
    title: footerSettings?.shopLinks?.title || '',
    links: getInternalLinks
  };

  const getMenus = (): SimpleFooterMenuItem[] =>
    hasPageLink ? [getPageLink, ...menus.slice(1)] : menus;

  return (
    <div className={styles.root}>
      {getMenus().map((menu) => (
        <FooterMenuItem key={menu.title} {...menu} />
      ))}
    </div>
  );
};

export default FooterMenu;
